{
  "proceduralCadence": {
    "stepFrames": 1,
    "continuousMotionEnabled": false
  },
  "reactionStagger": {
    "enabled": true,
    "defensiveLineFrames": 0,
    "linebackerFrames": 2,
    "cornerFrames": 3,
    "safetyFrames": 4,
    "blitzFrames": 1,
    "maximumHoldPixels": 5
  },
  "pursuitLanes": {
    "enabled": true,
    "minimumCarrierDistancePixels": 28,
    "maximumCarrierDistancePixels": 210,
    "maximumPursuers": 4,
    "crowdWidthPixels": 34,
    "spacingPixels": 3,
    "maximumOffsetPixels": 6
  },
  "contactImpact": {
    "windowFrames": 6,
    "holdFrames": 2,
    "carrierRecoilPixels": 0.9,
    "tacklerDrivePixels": 0.55,
    "horizontalCompression": 0.035,
    "verticalCompression": 0.05,
    "maximumRotationRadians": 0.032,
    "fumble": {
      "windowFrames": 10,
      "holdFrames": 3,
      "carrierRecoilPixels": 1.8,
      "tacklerDrivePixels": 0.95,
      "horizontalCompression": 0.06,
      "verticalCompression": 0.09,
      "maximumRotationRadians": 0.062
    }
  },
  "fumbleBurst": {
    "windowFrames": 9,
    "maximumRadiusPixels": 28,
    "minimumRadiusPixels": 11,
    "maximumAlpha": 0.82,
    "rayLengthPixels": 9
  },
  "catchAnticipation": {
    "minimumTracking": 0.12,
    "fullTrackingDistancePixels": 28,
    "maximumTrackingDistancePixels": 170,
    "gatherPixels": 0.48,
    "liftPixels": 0.34,
    "maximumRotationRadians": 0.038
  },
  "airborneBallShadow": {
    "minimumHeight": 0.08,
    "heightToPixels": 14,
    "minimumHalfWidthPixels": 3,
    "maximumHalfWidthPixels": 6,
    "heightPixels": 2,
    "maximumAlpha": 0.3,
    "minimumAlpha": 0.12
  },
  "puntCamera": {
    "changeover": {
      "responseRate": 5.5,
      "maxSpeed": 620,
      "maxAcceleration": 1400
    },
    "flight": {
      "responseRate": 4.6,
      "maxSpeed": 350,
      "maxAcceleration": 900
    },
    "return": {
      "responseRate": 3.8,
      "maxSpeed": 320,
      "maxAcceleration": 650
    }
  }
}
